import { get } from '../utils/axios'


export const getTravelsAPI = async () => {
  return await get('travels')
}
